const value = {
    label: 'Войти в систему',
    btnLabel: 'Войти',
    login: 'Логин',
    password: 'Пароль',
    method: 'Метод входа',
    basic: 'Локальный вход',
    incorrectValid: 'Неверный логин или пароль',
  };

export default value;
